import { Routes, Route } from "react-router";
import { useSelector } from "react-redux";
import { HasPermission } from "Core/security";
import { Navigate } from "react-router-dom";

//Views
import ScheduledActionsMain from "Modules/scheduledActions/views/main";

const RouterScheduledActions = (props) => {
    const user = useSelector(state => state.securityRedux.user);
    return (
        <>
            <Routes>
                {HasPermission(user, "schact") && <Route path="list" element={<ScheduledActionsMain />} />}
                <Route path="*" element={<Navigate to="/error" />} />
            </Routes>
        </>
    )
}
export default RouterScheduledActions;